import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ArrowTopIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12.0001 11.5257L15.8211 15.3467C16.2351 15.7607 16.9071 15.7607 17.3211 15.3467C17.7351 14.9327 17.7351 14.2607 17.3211 13.8467L12.7071 9.23273C12.3161 8.84173 11.6831 8.84173 11.2931 9.23273L6.67909 13.8467C6.26509 14.2607 6.26509 14.9327 6.67909 15.3467C7.09309 15.7607 7.76509 15.7607 8.17909 15.3467L12.0001 11.5257Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ArrowTopIcon.propTypes = {
  sx: PropTypes.object,
};

export default ArrowTopIcon;
